import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope } from "@fortawesome/free-regular-svg-icons"

const LocationHours = ({ address, tel, hours, image, email }) => {
  return (
    <div className="flex justify-center flex-col md:flex-row">
      <div className="image shadow-2xl">
        <img className="max-w-2xl h-full hidden lg:block object-cover" src={image} />
      </div>
      <div className="flex flex-col relative shadow-2xl ">
        <div className="flex-1 bg-green-800 white text-center p-16">
          <h3 className="uppercase text-xl">Location</h3>
          <p>{address.street}</p>
          <p>{address.town}, {address.postcode}</p>
          <p>{tel}</p>
        </div>
        <div className="bg-white absolute text-gray-800 border border-gray-200 py-6 left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-48 hover:shadow-md cursor-pointer">
          <a href={`mailto:${email}`} className="uppercase p-4 font-medium" >Get in touch <FontAwesomeIcon icon={faEnvelope} /></a>
        </div>
        <div className="flex-1 bg-white text-gray-800 text-center p-16">
          <h3 className="uppercase text-xl">Weekly Hours</h3>
          {hours.map((hours, idx) => {
            return (
              <p key={idx}>
                {formatHours(hours)}
              </p>
            )
          })}
        </div>
      </div>
    </div>
  )
}

function formatHours(hours) {
  const d = hours.split(' ')
  const days = d[0].split(',')
  const time = d[1]
  return `${days.map(d => d.replace(/(^\w|\s\w)/g, m => m.toUpperCase())).join(', ')}: ${time}`
}

export default LocationHours
